export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT"
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const TRANSACTIONS_FAILED = "TRANSACTIONS_FAILED";
export const SET_TOTAL = "SET_TOTAL";
export const GET_SUCCESSFUL = "GET_SUCCESSFUL";
export const SET_TOTAL_SUCCESSFUL = "SET_TOTAL_SUCCESSFUL";
export const GET_PENDING_TRANSACTIONS = "GET_PENDING_TRANSACTIONS";
export const GET_ALL_VOUCHERS = "GET_ALL_VOUCHERS";
export const GET_USED_VOUCHERS = "GET_USED_VOUCHERS";
export const GET_UNUSED_VOUCHERS = "GET_UNUSED_VOUCHERS";
export const VOUCHERS_FAILED = "VOUCHERS_FAILED";